import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { colors } from '../../../global';
import { media } from '../../../services/media';
import { themeStyles } from '../../../services/themeStyles';

const Formue = themeStyles(
    'formue',
    css`
        background-color: ${colors.stratos};
    `,
);

const Penge = themeStyles(
    'pengestyrke',
    css`
        background-color: ${colors.white};
    `,
);

const Upscore = themeStyles(
    'upscore',
    css`
        background: ${colors.turquoiseGreenGradient};
    `,
);

export const Bar = styled.span`
    display: block;

    height: 19%;

    margin-right: 0;
    margin-left: auto;

    border-radius: 5px;

    background-size: 29px 16px;

    ${Formue}
    ${Upscore}
    ${Penge}

    ${media.min('md')} {
        background-size: 45px 25px;
    }

    ${media.min('lg')} {
        background-size: 65px 37px;
    }

    &:not(:last-of-type) {
        margin-bottom: 14%;
    }

    &:nth-of-type(1) {
        width: 79%;

        background-position: top center;
    }

    &:nth-of-type(2) {
        width: 100%;

        background-position: center center;
    }

    &:nth-of-type(3) {
        width: 55%;

        background-position: bottom center;
    }
`;
